import React from 'react';
import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image';
import './ThemedIcon.scss';

export interface IFormIcons {
    background: `white` | `gray` | `dark`;
    iconAltTag?: string;
    iconText?: string;
    iconImg?: {
        blueLine: IGatsbyImageData;
        whiteSticker: IGatsbyImageData;
        blueSticker: IGatsbyImageData;
    };
}

export const ThemedIcon = (props: IFormIcons) => {
    if (!props.iconText && !props.iconImg) {
        return null;
    }
    let image: IGatsbyImageData;
    if (props.iconImg) {
        if (props.background === `white`) {
            image = props.iconImg.whiteSticker;
        } else if (props.background === `dark`) {
            image = props.iconImg.blueSticker;
        } else {
            image = props.iconImg.blueLine;
        }
    }

    return (
        <li className={`c--themed-icon`}>
            {image && (
                <GatsbyImage
                    image={getImage(image)}
                    alt={props.iconAltTag ?? ``}
                />
            )}
            {props.iconText && (
                <div
                    className="icon-text"
                    dangerouslySetInnerHTML={{
                        __html: props.iconText,
                    }}
                />
            )}
        </li>
    );
};
